import React from 'react';

function NotFound() {
  return <>Not Found</>;
}

export default NotFound;
